import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TokenStorageService } from 'viewbid-shared-lib';

const CACHE_KEY: string = 'newsletterSubscriptionStatus';

interface CachedSubscriptionStatus {
    email: string;
    subscribed: boolean;
    // For diagnostic purpuses, currently unused in the frontend
    fetchedAt: number;
}

@Injectable({ providedIn: 'root' })
export class NewsletterSubscriptionCacheService {
    private readonly statusSubject =
        new BehaviorSubject<CachedSubscriptionStatus | null>(null);

    constructor(private readonly tokenStorage: TokenStorageService) {
        this.statusSubject.next(
            this.tokenStorage.getLocalStorageItem(CACHE_KEY),
        );
    }

    getCached(email: string): boolean | null {
        const cached: CachedSubscriptionStatus | null =
            this.statusSubject.value;
        if (!cached || cached.email !== email) {
            return null;
        }
        return cached.subscribed;
    }

    set(email: string, subscribed: boolean): void {
        const status: CachedSubscriptionStatus = {
            email,
            subscribed,
            fetchedAt: Date.now(),
        };
        this.statusSubject.next(status);
        this.tokenStorage.setLocalStorageItem(CACHE_KEY, status);
    }
}
